document.addEventListener('DOMContentLoaded', function () {
  const banner = document.getElementById('discount-banner');
  const closeButton = document.querySelector('.discount-banner__close');

  // Check if the user has already closed the banner
  if (!localStorage.getItem('discountBannerHidden')) {
    banner.classList.remove('hidden');
  }

  // Handle close button click
  closeButton.addEventListener('click', function () {
    banner.classList.add('hidden');
    localStorage.setItem('discountBannerHidden', 'true');
  });
});
